<template>
  <div class="player-container">
    <el-row>
      <el-col :span="3"  style="padding-left: 10px;">
        <el-upload
          :on-success="handleSuccess"
          :on-error="handleError"
          :before-upload="beforeUpload"
          :show-file-list="false"
          :data="upload.dataObj"
          :action="upload.qiniuUp"
          :accept="upload.accept">
          <el-button type="primary" :loading="useLoading">导入训练数据</el-button>
        </el-upload>
      </el-col>
      <el-col :span="8">
        <el-button @click="getTemplate">下载训练模板</el-button>
      </el-col>
    </el-row>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="loginId">
        <template slot="header" slot-scope="scope">
          <div>账号</div>
          <el-input
            v-model="search.loginId"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot="header" slot-scope="scope">
          <div>姓名</div>
          <el-input
            v-model="search.trueName"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getGameListRouter(scope.row)">{{scope.row.trueName}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatAudit"
        prop="status">
        <template slot="header" slot-scope="scope">
          <div>审核状态</div>
          <el-select v-model="search.status" filterable @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in auditStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope" >
          <el-select
            v-model="scope.row.status"
            filterable
            @change="reviseState('audit', scope)" >
            <el-option v-for="item in auditStateList" v-show="item.value!==''" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatPayment"
        width="120"
        prop="paymentStatus">
        <template slot="header" slot-scope="scope">
          <div>付费状态</div>
          <el-select v-model="search.paymentStatus" filterable @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in payStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope" >
          <el-select
            v-model="scope.row.paymentStatus"
            filterable
            @change="reviseState('payment', scope)" >
            <el-option v-for="item in payStateList" v-show="item.value!==''" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="160"
        prop="payDate">
        <template slot="header" slot-scope="scope">
          <div>付费时间</div>
          <el-date-picker
            v-model="search.payDate"
            @change="quickSearch"
            type="date"
            placeholder="选择日期" />
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatPayment"
        width="120"
        prop="insuranceStatus">
        <template slot="header" slot-scope="scope">
          <div>保险状态</div>
          <el-select v-model="search.insuranceStatus" filterable @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in payInsureStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <div style="cursor: pointer;" @click="handleInsure(scope.row)">{{scope.row.insurance && scope.row.insurance.PayStatic == 1 ? '已支付': '待支付'}}</div>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="160"
        prop="createDate">
        <template slot="header" slot-scope="scope">
          <div>创建时间</div>
          <el-date-picker
            v-model="search.createDate"
            @change="quickSearch"
            type="date"
            placeholder="选择日期" />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-if="checkPermission(['user-inReferee-edit'])"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            v-else
            @click="handleRead(scope.$index, scope.row)">查看</el-button>
          <el-button
            size="mini"
            type="danger"
            v-permission="['user-inReferee-delete']"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <el-dialog
      :visible.sync="dialogVisibleSelectTime"
      :before-close="dialogHideSelectTime"
      title="提示"
      width="30%">
      <span class="demonstration">选择手动支付时间</span>
      <el-date-picker
        v-model="paymentTime"
        class="input-win"
        type="datetime"
        placeholder="选择日期">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogHideSelectTime">取 消</el-button>
        <el-button type="primary" @click="setPaymentStatus">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 保险详情 modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="保险详情" center>
      <el-form :model="insureObjRoot" :rules="rules" ref="dialogForm" class="modal" label-width="100px">
        <el-form-item label="投保批次号">
          <el-input v-model="insureObjRoot.insurance.TeamNo" readonly />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="insureObjRoot.insurance.OrderNo" readonly />
        </el-form-item>
        <el-form-item label="保单号">
          <el-input v-model="insureObjRoot.insurance.PolicyNo" readonly />
        </el-form-item>
        <el-form-item label="支付状态">
          <el-input v-model="insureObjRoot.insurance.PayStaticName" readonly />
        </el-form-item>
        <el-form-item label="保险方案ID">
          <el-input v-model="insureObjRoot.insurance.InsureNo" readonly />
        </el-form-item>
        <el-form-item label="保险方案名称">
          <el-input v-model="insureObjRoot.insurance.InsureTitle" readonly />
        </el-form-item>
        <el-form-item label="总费用">
          <el-input v-model="insureObjRoot.insurance.TotBill" readonly />
        </el-form-item>
        <el-form-item label="投保时间">
          <el-input v-model="insureObjRoot.insurance.InsureTimeName" readonly />
        </el-form-item>
        <el-button v-if="insureObjRoot.insurance.OrderNo" type="primary" @click="downloadPDF(insureObjRoot.insurance.OrderNo, insureObjRoot.insurance.PolicyNo)">下载保单</el-button>
        <el-button type="danger" v-if="insureObjRoot.insurance.TeamNo" @click="onSetRefund(insureObjRoot)">刷新信息</el-button>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 保险详情 modal end -->
  </div>
</template>

<script>

import * as moment from 'moment'
import find from 'lodash/find'
import permission from '@/directive/permission/index.js' // 权限判断指令
import checkPermission from '@/utils/permission' // 权限判断函数

import { adminGetAllRefereeList, AdminImportRefereeTrainingData } from '@/api/referee'
import {
  getAuditList,
  getInsurePaymentList,
  getPaymentList,
  updateMembershipStatus,
  updatePaymentStatus,
  getInsureOrder, AdminRefundMembershipInsurance
} from '@/api/user'
import {ConstConfig, showMessage, varConfig} from "@/utils";
import {getQiniuUploadToken} from "@/api/site";
import { MessageBox } from 'element-ui'

const defaultForm = {}

export default {
  name: 'PlayerList',
  directives: { permission },
  data() {
    return {
      useLoading:false,
      upload:{
        dataObj: { token: '' },
        qiniuUp: varConfig.qiniuUp,
        accept: ConstConfig.acceptXls,
      },
      search: {},
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 10, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      roleList: [],
      isEditMode: false,
      modalTitle: '',
      dialogForm: {},
      dialogVisible: false,
      formLabelWidth: '100px',
      auditStateList: [],
      payStatusList: [],
      payInsureStateList: [],
      imageUrl: '',
      rules: {
        mobile: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '目前只支持中国大陆的手机号码' }
        ],
        membershipTypeId: [
          { required: true, message: '请选择用户身份', trigger: 'blur' }
        ]
      },
      dialogFormVisible: false,
      dialogVisibleSelectTime: false,
      paymentStatusParams: {},
      paymentTime: null,
      insureObjRoot: {insurance:{}}
    }
  },
  created() {
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page, 10)
    }
    this.getQiniuToken()
    this.getList()
    this.getAuditList()
    this.getPaymentList()
    this.getInsurePaymentList()
  },
  computed: {
  },
  methods: {
    checkPermission,
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        showMessage('error', '上传头像图片大小不能超过 10MB!')
      }
      return isLt2M
    },
    getTemplate() {
      window.open("http://image.bjh.snsports.cn/%E8%AE%AD%E7%BB%83%E6%88%90%E7%BB%A9%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls", '_blank')
    },
    handleSuccess(response) {
      this.useLoading = true
      const params = {
        url: response.key
      }
      AdminImportRefereeTrainingData(params).then(response=>{
        const data = response.data
        if(data) {
          let sc = data.yes
          let no = data.no
          let msg;
          let type
          if(sc <= 0) {
            msg = `失败:${no}`
            type = 'error'
          } else if(no.length > 2 ) {
            msg = `成功导入:${sc}人, 失败:${no}`
            type = 'warning'
          } else {
            msg = `成功导入:${sc}人`
            type = 'success'
          }
          MessageBox.confirm(msg, "结果", {type: type})
        }
        this.useLoading = false
      })
    },
    onSetRefund(item){
      const data = {TeamNo: item.insurance.TeamNo}
      AdminRefundMembershipInsurance(data).then(res=>{
        debugger
        const data = res.data
        if(data) {
          item.insurance = data.insurance || {}
          item.insurance.PayStaticName = item.insurance.PayStatic === 1 ? '已支付' : '待支付'
          item.insurance.InsureTimeName = this.formatDateTime(item.insurance.InsureTime)
          // this.dialogVisible = false
        }
      })
      //this.$confirm('此操作无法撤回, 是否继续?', '提示', {
      //  confirmButtonText: '确定',
      //  cancelButtonText: '取消',
      //  type: 'warning',
      //  center: true
      //}).then(() => {
      //
      //}).catch(() => {
      //})
    },
    handleError() {
      showMessage('error', "上传失败");
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.upload.dataObj.token = data.token
      }).catch(err => {
        console.log(err, 'error', '七牛Token获取失败')
      })
    },
    getGameListRouter(row){
      return {path: `/league/referee-match-list/${row.id}/${row.userId}`}
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleInsure(item) {
      this.dialogVisible = true
      item.insurance = item.insurance || {}
      item.insurance.PayStaticName = item.insurance.PayStatic === 1 ? '已支付' : '待支付'
      item.insurance.InsureTimeName = this.formatDateTime(item.insurance.InsureTime)
      this.insureObjRoot = item
    },
    downloadPDF (orderNo, policyNo) {
      const params = {
        orderNo: orderNo,
        pno: policyNo
      }
      getInsureOrder(params).then(response => {
        const data = response.data
        if (data && data.url) {
          window.location.href = data.url
        }
      })
    },
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加用户信息'
      this.dialogForm = defaultForm
    },
    handleEdit(index, row) {
      this.$router.push({ name: 'InRefereeEdit', params: { id: row.id }})
    },
    handleRead(index, row) {
      this.$router.push({ name: 'InRefereeDetails', params: { id: row.id }})
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deletePlayer(this.list[index].id)
      }).catch(() => {
      })
    },
    getInsurePaymentList() {
      this.payInsureStateList = getInsurePaymentList()
    },
    formatPayment: function(row, column) {
      const value = row[column.property]
      const obj = find(this.payStateList, function(item) {
        return item.value === value
      })
      return obj && obj.label
    },
    // dialog form methods
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEditMode) {
            this.updatePlayer()
          } else {
            this.addPlayer()
          }
        } else {
          return false
        }
      })
    },
    handleCurrentChange(val) {
      this.$router.push({path: this.$route.path, query: {page: val}})
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        inField: 1
      }
      if (this.search.createDate) {
        this.search.createDate = moment(this.search.createDate).format('YYYY-MM-DD')
      }
      if (this.search.payDate) {
        this.search.payDate = moment(this.search.payDate).format('YYYY-MM-DD')
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      adminGetAllRefereeList(this.listQuery).then(response => {
        const data = response.data
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
      })
    },
    getPlayerById(userId) {
      getPlayerById(userId).then(response => {
        const data = response.data
        this.dialogForm = data.user
      })
    },
    addPlayer() {
      addPlayer(this.dialogForm).then(response => {
        const data = response.data
        if(data && data.player) {
          this.dialogVisible = false
          this.$message({
            message: '创建成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    updatePlayer() {
      const data = {
        userId: this.dialogForm.id,
        trueName: this.dialogForm.trueName,
        password: this.dialogForm.password,
        email: this.dialogForm.email
      }
      updatePlayer(data).then(response => {
        const data = response.data
        if(data) {
          this.$message({
            message: '更新成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    deletePlayer(userId) {
      const params = {
        id: userId,
        status: -2
      }
      updateMembershipStatus(params).then(response => {
        const data = response.data
        if (data) {
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    getAuditList() {
      this.auditStateList = getAuditList()
    },
    getPaymentList() {
      this.payStateList = getPaymentList()
    },
    formatAudit: function(row, column) {
      /*
      const value = row[column.property]
      const obj = find(this.auditStateList, function (item) {
        return item.value == value
      });
      return obj&&obj.label
      */
    },
    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    reviseState(type, status) {
      let params = this.paymentStatusParams = {
        id: status.row.id,
        status: status.row.status,
        remark: '' // TODO
      }
      if (type === 'payment') {
        params.paymentStatus = status.row.paymentStatus
        if (status.row.paymentStatus === 2) {
          this.dialogVisibleSelectTime = true
        } else {
          this.updatePaymentStatus(params)
        }
      } else if (type === 'audit') {
        if (status.row.status === 1) {
          this.$prompt('请输入审核未通过原因', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            beforeClose: (action, instance, done) => {
              if (action === 'cancel') {
                this.getList()
                done()
              } else if (action === 'confirm') {
                done()
              }
            }
          }).then(({ value }) => {
            params.remark = value
            this.updateMembershipStatus(params)
          }).catch(() => {
            return false
          })
        } else {
          this.updateMembershipStatus(params)
        }
      }
    },
    updateMembershipStatus(param) {
      const params = param
      updateMembershipStatus(params).then((resolve) => {
        this.$message({
          message: '审核状态修改成功',
          type: 'success'
        })
      }, (reject) => {
        this.$message({
          message: '审核状态修改失败',
          type: 'error'
        })
      })
    },
    updatePaymentStatus(params) {
      updatePaymentStatus(params).then((res) => {
        if (res.data) {
          this.$message({
            message: '支付状态修改成功',
            type: 'success'
          })
          this.getList()
        }
      }, (err) => {
        this.$message({
          message: '支付状态修改失败',
          type: 'error'
        })
      })
    },
    dialogHideSelectTime() {
      this.getList()
      this.dialogVisibleSelectTime = false
    },
    setPaymentStatus() {
      this.paymentStatusParams.payDate = this.paymentTime || moment().format('YYYY-MM-DDTHH:mm:ss+0800')
      this.updatePaymentStatus(this.paymentStatusParams)
      this.dialogVisibleSelectTime = false
    },
    formatDateTime: function(date) {
      return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .player-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
      th>{
        .cell {
          text-overflow: clip;
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }
  }
</style>
